import React from 'react'
import PropTypes, { node, number, object, string } from 'prop-types'
import { Box } from '@mui/material'

// Dùng để chỉ định được số dòng muốn hiển thị, phần nội dung vượt quá sẽ bị ẩn đi và thay thế bởi dấu 3 chấm.
const TextEllipsis = ({
  color = '#000',
  children,
  fontWeight,
  fontSize,
  margin,
  lineHeight = '1.6rem',
  component,
  numberLine = 1,
  className,
  ...passProps
}) => {
  const styles = {
    WebkitLineClamp: numberLine,
    overflow: 'hidden',
    WebkitBoxOrient: 'vertical',
    display: '-webkit-box',
  }

  return (
    <Box
      className={className}
      color={color}
      lineHeight={lineHeight}
      margin={margin}
      component={component}
      fontWeight={fontWeight}
      fontSize={fontSize}
      sx={styles}
      {...passProps}>
      {children}
    </Box>
  )
}

export default React.memo(TextEllipsis)

TextEllipsis.propTypes = {
  color: string,
  children: string,
  numberLine: PropTypes.oneOfType([number, string]),
  fontWeight: string,
  lineHeight: string,
  fontSize: string,
  component: PropTypes.oneOf(['div', 'h1', 'h2', 'h3', 'h4', 'p']),
  margin: string,
  passProps: object,
  className: node,
}
